import React, {  useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, Typography } from "@material-tailwind/react";
import { getSeedFileInfo } from "../../api/axiosApi";

function SingleSeedInfo() {
    const { seedId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [seeds, setSeeds] = useState<any>([]);

    const getSpecificSeedInfo = async () => {
        setIsLoading(true);
        if (seedId !== null) {
            try {              
                const historyResponse = await getSeedFileInfo(seedId);
                const data = await historyResponse.data;
                setSeeds(data);
            } catch (error) {
                setError(true);
                console.error(`Failed to fetch seed file info `, error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        getSpecificSeedInfo();
    }, [seedId]); 

    if (isLoading) {
        return (
            <div className="m-2 ">
                <div className=" flex items-center justify-center rounded-xl bg-white animate-pulse h-14 w-full shadow-lg ">
                    <Typography as="div" variant="paragraph" className="mb-2 h-4 w-7/12 rounded-full bg-gray-400">
                        &nbsp;
                    </Typography>
                </div>
                <div className="mt-2">
                    <div className="mt-2 leading-7">
                        <Card className="h-[27vh]">
                            <CardBody className="pl-4 pt-10 overflow-auto">
                                {" "}
                                <div className="animate-pulse ">
                                    <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                        &nbsp;
                                    </Typography>
                                    <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                        &nbsp;
                                    </Typography>
                                    <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                        &nbsp;
                                    </Typography>
                                    <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                        &nbsp;
                                    </Typography>
                                    <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                        &nbsp;
                                    </Typography>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>

                <div className="mt-2 leading-7">
                    <Card className="h-[48vh]">
                        <CardBody className="pl-4 pt-10 overflow-auto">
                            <div className="animate-pulse">
                                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                    &nbsp;
                                </Typography>
                                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                    &nbsp;
                                </Typography>
                                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                    &nbsp;
                                </Typography>
                                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                    &nbsp;
                                </Typography>
                                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12  rounded-full bg-gray-400">
                                    &nbsp;
                                </Typography>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                {seeds.link ? (
                    <div className="mt-2 ">
                        <a href={seeds.link} target="_blank" className="text-blue-700 cursor-pointer">
                            {seeds.title}
                        </a>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }

    return (
        <div className="m-2 min-w-96">
            <div className=" flex items-center justify-between rounded-xl bg-white  h-14 w-full shadow-lg gap-1">
                <div className="text-lg font-title flex-grow flex-shrink text-left pl-4 truncate" title={seeds.author}>{seeds.author}</div>
                <div className="text-lg font-title flex-grow flex-shrink text-center truncate" title={seeds.title}>{seeds.title}</div>
                <div className="text-lg font-title flex-grow flex-shrink text-right pr-4 truncate " title={seeds.date}>{seeds.date}</div>
            </div>

            <div className="mt-2">
                <div className="mt-2 leading-7">
                    <Card className="h-[27vh]">
                        <h2 className="pt-2 pl-4 font-title">Brief</h2>
                        {seeds.brief_summary && <CardBody className="pl-4 pt-2 overflow-auto">{seeds.brief_summary}</CardBody>}
                    </Card>
                </div>
            </div>

            <div className="mt-2 leading-7">
                <Card className="h-[48vh]">
                    <h2 className="pt-2 pl-4 font-title">Elaboration</h2>
                    {seeds.elaborate_summary && <CardBody className="pl-4 pt-2 overflow-auto">{seeds.elaborate_summary}</CardBody>}
                </Card>
            </div>

            {seeds.link ? (
                <div className="mt-2 ">
                    <a href={seeds.link} target="_blank" className="text-blue-700 cursor-pointer">
                        {seeds.title}
                    </a>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}

export default SingleSeedInfo;
